import React from 'react';
import Media from 'react-responsive';
import styles from '../SearchResults.scss';
import mobileStyles from '../SearchResultsMobile.scss';


export default function SearchPageHeader(props) {
    let foundDetail = props.foundDetail;
    let query = props.searchQuery;
    let isCartEmpty = props.isCartEmpty;
    if(!foundDetail || !foundDetail.detailNum)
    {
      // TODO: for mobile too!
      return (
        <h2 className={styles.searchResultsHeader}><span>Артикул не найден</span></h2>
      );
    }
  return (
    <div className="row">
      <div className="col-12">
      <Media query="(min-width: 1025px)">
        <h2 className={styles.searchResultsHeader}>
          {/*isCartEmpty ? <span>Артикул {foundDetail.detailNum} найден в {10} магазинах Москвы</span> : */<span>Результаты поиска артикула {foundDetail.detailNum} </span>}
        </h2>
      </Media>

      <Media query="(max-width: 1024px)">
        <h3 className={mobileStyles.header_row}>
          <strong>
          Артикул {foundDetail.detailNum}
          </strong>
        </h3>
      </Media>
      </div>
    </div>
  );
}



/** WEBPACK FOOTER **
 ** ./src/components/SearchResults/elements/SearchPageHeader.jsx
 **/